/* eslint-disable max-len */
export default {
  cfmoto: {
    AIReview: 'АИ преглед',
    AIReviewFailed: 'АИ преглед није успео',
    AIReviewPassed: 'АИ преглед је прошао',
    AIReviewStatus: 'Статус прегледа АИ',
    AIReviewing: 'Преглед АИ је у току',
    America: {},
    CheckSupportInstall: 'Провери да ли је подкреплено повторение',
    ImporterCommunityDisplayName: 'Prikazano ime zajednice uvoznika',
    ImporterContactEmail: 'Kontakt e-mail uvoznika',
    IndicatorLight: 'индикаторска лампица',
    Instruction: 'Објава',
    MostPicture4OrVideo: '(Do 4 slika/1 video)',
    PleaseContactPersonnelCommunicating: 'Molim vas, kontaktirajte osoblje CFMOTO za komunikaciju',
    USD: {},
    UnbindingApplicationCommitment: {},
    aboutAccount: 'O nalogu',
    aboutVehicle: 'O vozilu',
    accountApplyRejected: 'Zahtev za brisanje naloga je odbijen',
    accountCancel: 'Zahtevi za brisanje naloga',
    accountDeletExplain: 'Uputstva za brisanje naloga',
    accountDelete: 'Brisanje naloga',
    accountDeleted: 'Nalog je izbrisan',
    accountFormatError: 'Neispravan format naloga/korisnik ne postoji. Molimo vas da uskladite odgovarajući tekst na osnovu stvarnog uzroka',
    action: 'Operacija',
    actionFail: 'Операција неуспела',
    actionSuccess: 'Operacija je bila uspešna',
    activeScore: 'Активно бодовање',
    activeTrigger: 'Корисници активно покрећу (О АПП—Иди на оцену)',
    activity: 'Aktivnosti',
    activityCancel: 'Otkazivanje događaja',
    activityCover: 'Naslovna strana događaja',
    activityDetails: 'Detalji aktivnosti',
    activityId: 'ИД активности',
    activityList: 'Spisak aktivnosti',
    activityManagement: 'Upravljanje događajima',
    activitySearch: 'Aktivna pretraga',
    activityTime: 'Vreme događaja',
    activityTitle: 'Naslov događaja',
    activityVenue: 'Lokacija događaja',
    adaptable: 'Prilagodi za',
    add: 'dodaj',
    addAccountDeletExplain: 'Dodaj obaveštenje o brisanju naloga',
    addAuthenticationTime: 'Dodaj vreme autentifikacije',
    addDataDeletExplain: 'Dodavanje obaveštenja o brisanju podataka',
    addEmail: 'Нова е-маил',
    addExhibitionCategory: {},
    addExhibitionSeries: {},
    addInformationCategory: 'Додајте нову категорију информација',
    addInformationContent: 'Додајте нови садржај информација',
    addKolUserAuthentication: 'Dodaj KOL autentifikaciju korisnika',
    addPicture: 'Додај слику',
    addPrivacyAgreement: 'Додајте уговор о приватности',
    addPrivacySubmitSure: 'Датум ступања на снагу и опис промене нове политике приватности не могу се прилагођавати након подношења. Потврдите подношење.',
    addPushConfiguration: 'Dodajte push podešavanja',
    addQuestion: {},
    addSdkStaement: 'Додај СДК декларацију',
    addServiceIntroduce: 'Uvod za nove usluge',
    addShowroomModel: 'Dodaj modele pokazivanja',
    addThisUser: 'Dodaj ovog korisnika',
    addTopic: 'Dodavanje teme',
    addUser: 'Dodavanje korisnika',
    addUserAgreement: 'Dodaj korisnički ugovor',
    addUserRole: 'Dodaj ulogu korisnika',
    addVehicleModel: 'Нови модели',
    addVehicleModelCategory: 'Nova kategorija vozila',
    addVideo: 'Додај видео',
    addedBy: 'Dodao\n',
    additionalFeedback: 'Допълни отговор',
    administratorUnbind: 'Administrator se ne povezuje',
    afternoon: 'Popołudnie',
    agreeSignOut: 'Saglasnost na prekid radnog odnosa',
    agreementContent: 'Договор',
    all: 'Cав',
    allArea: 'Циљна земља/регион',
    allComment: 'Svi komentari',
    allImportSuccess: 'Uvoz završen. Sve je uspešno uvezeno',
    allUser: 'Svi korisnici',
    allVehicleModel: 'Сви модели',
    alreadyOver: 'Sve ovde',
    android: 'Андроид',
    answer: {},
    answerOta1: 'ОТА значи да возило преузима најновији софтвер фирмвера из облака преко мобилне мреже, а возило можете надоградити на мрежи преко ЦФМОТО РИДЕ-а да бисте континуирано оптимизовали искуство вожње',
    answerOta2: 'When new version of the tft display that can be upgraded, you will receive the upgrade notification.  Ako se %s prikazuje na dnu trenutne stranice, znači da se prikaz vozila tft ne mora poboljšati.',
    answerOta3: 'Možete kliknuti %s u gornjem desnom kutu da naučite još instrukcija za operaciju OTA unaprijed',
    anyCar: 'Imate li auto?',
    appRating: 'Управљање механизмом бодовања',
    appType: 'Телефонски систем',
    appVersion: 'АПП верзија',
    applicableCountry: {},
    applicableCountryName: {},
    applyTime: 'Vremenska osa aplikacije',
    applyUnbinding: 'Primeni poništavanje',
    appointmentReleaseTime: 'Време отпуштања термина',
    approval: 'Priznajem.',
    arrivalNumberDescription: 'Stvarni broj dolazaka na terminal uređaja nakon poslate poruke obaveštenja (dolasci posle 5 dana neće biti brojani)',
    arrivalNumberVolume: 'Broj dolazaka',
    askAllowUserSpeakInCommunity: 'Želite li da dozvolite blokiranom korisniku da objavljuje u zajednici',
    askApproveIt: 'Da odobrim',
    askDeleteCategory: {},
    askDeleteInformactionCategory: 'Да ли да избришете ову категорију информација',
    askDeleteInformationContent: 'Да ли да избришете информативни садржај',
    askDeleteKolUserAuthentication: 'Da li ste sigurni da želite da izbrišete ovu KOL autentifikaciju korisnika?',
    askDeleteQuestion: {},
    askDeleteThisActivity: 'Želite li da izbrišete ovu aktivnost',
    askDeleteThisBanner: 'Želite li da izbrišete ovaj baner',
    askDeleteThisComment: 'Jeste li sigurni da želite izbrisati ovaj komentar',
    askDeleteThisPost: 'Želite li da izbrišete ovu objavu',
    askDeleteThisTopic: 'Želite li da izbrišete ovu temu',
    askDeleteVehicleType: 'Are you sure to delete the vehicle model',
    askDeleteVehicleTypeCategory: 'Да ли да избришете ову категорију модела',
    askDeleteVehicleTypeDetails: 'Да ли да избришете детаље о моделу аутомобила',
    askDeleteVehicleTypeSeries: 'Да ли да избришете ову серију модела',
    askLogout: 'Jesi li siguran da želiš da izađeš iz sistema?',
    askNotApproveIt: 'Ne odobravate to',
    askSaveSettings: 'Подешавања још увек нису сачувана, да ли желите да их сачувате?',
    associatedPostNumber: 'Broj srodnih objava',
    associatedPosts: 'Srodni članci',
    associatedVehicle: 'повезано возило',
    assoclatedContent: 'Povezani sadržaj',
    atmosphereCContent: 'Подешавања још увек нису сачувана, да ли желите да их сачувате?',
    atmosphereContent1Msg1: 'Након што се функција укључи, мобилни телефон укључује Блуетоотх и АПП наставља да ради. Када се возило приближава издалека у близину, возило се може аутоматски откључати и укључити.',
    atmosphereContent1Msg2: 'Ако обично није откључан и укључен, притисните дугме за напајање возила да бисте откључали и укључили',
    atmosphereContent1Msg3: 'Аутоматско откључавање близине ће се покренути само једном пре него што се Блуетоотх искључи',
    atmosphereContent2Msg1: 'Након што је функција укључена, возило ће се аутоматски искључити након 5 секунди након три услова возила које се искључује, брзина возила је 0 и храм је пао',
    atmosphereContent2Msg2: 'Покретање возила током периода аутоматског искључивања, брзина возила није 0, или је храм одложен ће отказати аутоматско искључивање',
    atmosphereContent3Msg1: 'Након укључења функције, када је возило искључено, мобилни телефон укључује Блуетоотх и АПП наставља да ради или носи физички кључ. Када се приближавате возилу од далека до близине, светла возила ће трептати да дочекају госте',
    atmosphereContent3Msg2: 'Да би се спречило да чести окидачи изазивају губитак снаге возила, након што се функција добродошлице покрене два пута у року од 30 секунди, неће се наставити до 30 минута касније',
    atmosphereContent4Msg1: 'Након што се функција укључи, дуга и кратка светла ће се аутоматски укључити 10 секунди након што се возило искључи',
    atmosphereIntroduce1: 'Близу упутства за аутоматско откључавање',
    atmosphereIntroduce2: 'упутства за аутоматско искључивање',
    atmosphereIntroduce3: 'Упутства за аутоматско буђење',
    atmosphereIntroduce4: 'Одложено гашење светла',
    atmosphereSetINfo: 'Нова подешавања ће ступити на снагу у року од 1-3 минута након што се возило укључи, уверите се да је возило у добром сигналном положају',
    auditStatus: 'Стање одлуке о одобрењу',
    authenticatedName: 'Ime korisnika sa autentifikacijom',
    avatar: 'Avatar',
    backApply: 'povući prijavu',
    backApplySuccess: 'povlačenje prijave uspješno',
    backHome: 'Vratimo se kući.',
    bannerDisplayImages: 'Слика банера',
    bannerList: 'Lista reklamnih natpisa',
    bannerManagement: 'Upravljanje reklamnim natpisima',
    bannerPictrure: 'Crtež reklamnog natpisa',
    bannerSearch: 'Pretraga reklamnog natpisa',
    bannerTitle: 'Naslov reklamnog natpisa',
    batchImport: 'Grupni uvoz',
    batchUser: 'Grupni korisnici',
    beijingTime: 'UTC+8 време',
    belogCategory: 'категорија',
    belongCategory: {},
    bindDevice: 'Уређај за везивање',
    bindVehicle: 'Вези возило',
    bindingStatus: 'Статус свежења',
    bindingText1: '1.\tТелематицс Сервицес',
    bindingText10: '1.1.2.\tПружање планирања руте током навигације, укључујући израчунавање удаљености између возила и пјешачку навигацију у сврху проналажења возила .',
    bindingText11: '1.2.\tСлање потребних обавештења Купцу на основу стања возила.',
    bindingText12: '1.2.1.\tЦФМОТО ће прекинути обавештења Купца о одржавању возила (нпр. на основу укупне удаљености коју је корисник прешао, времена када је купац купио возило, захтеваног времена или удаљености вожње за одржавање возила) .',
    bindingText13: '1.2.2.\tНа основу података о возилу , ЦФМОТО ће купцу слати обавештења о ненормалној ситуацији; укључујући анализу података од стране ОЕМ (у зависности од модела) за пружање бриге о купцима и накнадну оптимизацију возила .',
    bindingText14: '1.3.\tПодршка у анализи узрока незгоде уколико Купац пријави тешку незгоду Возила.',
    bindingText15:
      '1.3.1.\tУ случају озбиљног удеса возила, као што је када се возило преврне или преврне на бок током вожње, ЦФМОТО ће подржати Купца на захтев да разјасни да ли је до незгоде дошло због квара на возилу или других околности. Купац подноси захтев ЦФМОТО-у преко локалног дистрибутера / продајног партнера наведеног у Уговору о продаји возила.',
    bindingText16: '1.3.2.\tУ мери у којој доступни подаци то дозвољавају, ЦФМОТО ће проценити податке у односу на узрок несреће и доставити Клијенту одговарајући извештај.',
    bindingText17: '1.4.\tПомоћ Купцу да поврати Возило након губитка Возила .',
    bindingText18: '1.4.1.\tАко се возило изгуби, ЦФМОТО ће клијенту доставити податке о локацији возила и друге корисне податке о статусу возила (као што је локација последње активације, тренутни статус возила, итд.) на захтев и ако су доступни.',
    bindingText19: '1.4.2.\tКупац подноси захтев ЦФМОТО-у преко локалног дистрибутера / продајног партнера наведеног у Уговору о продаји возила.',
    bindingText2:
      'ЦФМОТО Поверспортс, Инц. (у даљем тексту „ ЦФМОТО “ ) пружа услуге телематике возила купцу који је купио ЦФМОТО возило (у даљем тексту „Купац“ ). За ове услуге, ЦФМОТО користи податке снимљене од стране возила о возилу и његовом понашању у вожњи у релевантном временском периоду. Детаљније, ово се односи на следеће податке:',
    bindingText20: '1.5.\tПријављивање проблема након продаје .',
    bindingText21: '1.5.1.\tЦФМОТО прикупља даљински обавештења о кодовима грешке које возило шаље у случају квара његових компоненти и пружа одговарајуће информације на захтев Купца директно Купцу.',
    bindingText22: '1.5.2.\tКупац подноси захтев ЦФМОТО-у преко локалног дистрибутера / продајног партнера наведеног у Уговору о продаји возила.',
    bindingText23: '2.\tОграничења и искључења услуге',
    bindingText24: '2.1.\tИзричито се истиче да структурне или друге техничке промене на возилу могу ограничити пружање услуга или чак онемогућити, јер услуге зависе од тачности података о возилу.',
    bindingText25: '2.2.\tТамо где се такве услуге не могу пружити због перформанси било које треће стране података или телекомуникационих мрежа, било каква одговорност ЦФМОТО-а је искључена.',
    bindingText26: '3.\tПриватност',
    bindingText27:
      'ЦФМОТО ће се придржавати важећих прописа о заштити података када обрађује личне податке у вези са ЦФМОТО возилом . Услови политике приватности Ц ФМОТО -а наведени су у овој ЦФМОТО РИДЕ АПП. Као додатак политици приватности , његово обавештење је у складу са политиком приватности . Клијент се може позвати на политику приватности за неке садржаје који се односе на обраду података који нису обухваћени овим обавештењем.',
    bindingText28: '4.\tКориснички сервис',
    bindingText29:
      '4.1.\tКлијент може слободно да пошаље питања, коментаре или недоумице у вези са приватношћу на ЦФМОТОРИДЕАПП@цфмотоуса.цом или да пише на: ЦФМОТО Поверспортс, Инц., 3555 Холли Лане Нортх, Суите 30, Плимоутх, М Н 55447. Корисник такође може позвати ЦФМОТО Односи са клијентима на (888) 823-6686. ',
    bindingText3: 'Подаци о понашању корисника у вожњи : укључујући убрзање, успоравање, брзину, савијање, последње време вожње и последњу километражу .',
    bindingText30: '5.\tР евисионс',
    bindingText31: '5.1.\tЦФМОТО задржава право да промени ово обавештење у било ком тренутку, али ћемо објавити ревизије на ЦФМОТО РИДЕ Апликација и/или дајте обавештење пре него што то учинимо по потреби.',
    bindingText4:
      'Подаци о статусу возила: односе се на статус возила у реалном времену, укључујући режим вожње, преостало гориво, тренутну економичност горива, километражу, брзину возила у реалном времену, брзину мотора, притисак у гумама, температуру пнеуматика, податке о напону активирања батерије , температура расхладне течности, статус електронског закључавања, верзија софтвера интелигентног уређаја, јачина сигнала паметних уређаја, тренутна поставка контролне табле.',
    bindingText5:
      'Подаци о аларму возила: подаци о аларму који се шаљу ако одређени подаци премашују унапред подешену вредност, као што су температура мотора, превелика брзина, прекомерно време вожње, висока температура расхладне течности, ненормално кретање возила, ненормалан притисак у гумама, вибрације, испуштање, судар итд . .',
    bindingText6: 'Информације о грешци возила: односи се на кодове грешака које извештава сваки унутрашњи део возила.',
    bindingText7: 'Подаци о локацији возила: односе се на специфично географско боравиште возила.',
    bindingText8: '1.1.\tПровид инг Клијент са услугама у вези са возилом преко ЦФМОТО РИДЕ АПП .',
    bindingText9: '1.1.1.\tПотрошачи могу даљински управљати возилима преко ЦФМОТО РИДЕ АПП (укључујући преглед локације возила, подешавање информација о возилу и функција, даљинско управљање статусом возила, итд.).',
    bindingUser: 'Povezan korisnik',
    bound: 'Ограђено',
    businessType: 'Vrsta poslovanja',
    button: 'Knjiga',
    callbackedApply: 'Повукли сте пријаву за брисање налога yyyy-MM-dd HH:mm:ss',
    callbackedApplySyncTip:
      'Vaš Zahtev za brisanje naloga je podnet na yyyy-MM-dd HH:mm:ss.  Trajno ćemo izbrisati vaš nalog i povezane podatke 15 dana nakon prijema zahteva.  Kada izbrišete, više nećete moći da koristite CFMOTO RIDESYNC uslugu.  Ako je potrebno da otkažete brisanje naloga, posjetite web stranicu ili se prijavite u aplikaciju u roku od 15 dana da biste povukli zahtev za brisanje naloga.',
    callbackedApplyTip:
      'Vaš Zahtev za brisanje naloga je podnet na yyyy-MM-dd HH:mm:ss.  Trajno ćemo izbrisati vaš nalog i povezane podatke 15 dana nakon prijema zahteva.  Kada izbrišete, više nećete moći da koristite CFMOTO RIDE uslugu.  Ako je potrebno da otkažete brisanje naloga, posjetite web stranicu ili se prijavite u aplikaciju u roku od 15 dana da biste povukli zahtev za brisanje naloga.',
    cancel: 'Отмени',
    cancellationAgreement: 'Уговор о отказивању',
    cancelled: 'Cancelled',
    carOwner: 'Власник',
    carUserScore: 'Оцене власника возила',
    cardPass: 'Potvrda identiteta je uspešna!',
    cfmotoName: 'CFMOTO',
    changeCodeValidate: 'Prebaci se na CAPTCHA verifikaciju',
    changeDescriptionType: 'Промените опис',
    changeDescriptionTypeSelectNo: 'Не укључује промене у прописима о обради личних података',
    changeDescriptionTypeSelectYes: 'Промене прописа који се односе на обраду личних података',
    changeEmailInfo: 'Prebacite se na e-poštu',
    changeFail: 'Промена статуса није успела',
    changeOne: 'Промена',
    changePassValidate: 'Prebacivanje na verifikaciju lozinke',
    changePasswordFailed: 'Промена парола не успела',
    changePasswordSuccessful: 'Промена парола успешно',
    changePhoneInfo: 'Prebacite se na broj telefona',
    changeStore: 'Izmeni prodavnicu',
    changeSuccess: 'Статус је успешно измењен',
    channelType: 'канал повратних информација',
    characterLimitExceeded: 'Ograničenje broja znakova je prekoračeno',
    checkConfigurationTwo: 'Kineski ili engleski %s nije potpuno konfigurisan, molim vas, provjerite',
    checkCopyWriting: 'Кинески или енглески садржај није попуњен, проверите',
    checkEmpty: '%s је празан, проверите',
    checkTriggerType: 'Постоји услов механизма окидача који није попуњен, проверите',
    checkUpdate: 'Провери обновљање',
    cityFilter: 'Filter grada',
    clickImmediateFeedback: 'Кликните да бисте одмах дали повратне информације',
    clickNumber: 'Број кликова',
    clickNumberDescription: 'Stvarni broj klikova korisnika nakon što je obaveštenje uspešno prikazano (klikovi nakon 5 dana neće biti brojani)',
    clickNumberVolume: 'Broj klikova',
    clickToFeedback: 'Kliknite da se javite',
    clicks: 'Kliknite na dugme',
    closeNum: 'затварање',
    closeTask: 'Задатак је отказан',
    code: 'Verifikacijski kod',
    colorPicture: 'Slika bloka boja',
    comment: 'Komentar',
    commentContent: 'Komentare',
    commentList: 'Spisak recenzija',
    commentNumber: 'Broj komentara',
    commentTime: 'Vreme za komentare',
    communication: 'у комуникацији',
    community: 'Zajednica',
    communityManagement: 'Upravljanje zajednicom',
    communityRule: 'Pravila zajednice',
    completePuzzle: 'Molimo popunite slagalicu',
    completed: 'Dovršeno',
    condition: 'стање',
    configureLanguage: 'Конфигуришите језик',
    configurePicture: 'Конфигуришите слику',
    confirm: 'Potvrdi',
    confirmDeletePictures: 'Потврдите брисање ове слике',
    confirmReviewNoPass: 'Potvrdite neuspeh recenzije',
    confirmReviewPass: 'Potvrdite odobrenje recenzije',
    consultDealer: 'Молимо консултујте свог локалног продавца',
    contact: 'Vaša prijava za brisanje računa je odbijena. Ako imate bilo kakvih pitanja, kontaktirajte it@cfmoto.com radi konsultacija.',
    contactMail: 'E-adresa',
    contactMethod: 'Kontakt',
    contactUs: 'Kontaktirajte nas',
    content: 'Sadržaja',
    contentType: 'Tip sadržaja',
    copyFail: 'Копирање није успело',
    copyLink: 'Копирај везу',
    copySuccess: 'Kopirano uspješno',
    copyWriting: 'Искачући садржај',
    country: 'Земља/Регион',
    countryCode: 'Državni pozivni broj',
    countryName: 'Zemlja',
    countryNumber: 'Pozivni broj zemlje',
    countryRegion: 'Држава / Регион',
    create: 'Novi dodatak',
    createBy: 'Kreator',
    createStore: 'Kreiraj prodavnicu',
    createTime: 'vreme kreiranja',
    cs_CZ: 'чешки',
    currency: {},
    currentConfig: {},
    currentCountryStoreTotal: 'Ukupan broj prodavnica u trenutnoj zemlji',
    currentTime: 'Trenutno vreme',
    customPage: 'Prilagođena stranica',
    customSettings: 'Постојени колони',
    dataDeletExplain: 'Uputstva za brisanje podataka',
    dataDelete: 'Brisanje naloga',
    dataDeleteApply: 'Zahtevi za brisanje podataka',
    dataFormatError: 'Błąd formatu danych',
    dataPermissionScope: 'Обим дозволе за податке',
    dataType: 'Tip podataka',
    dayOne: 'дана једном',
    days: 'Dan',
    daysAgo: 'prije %s dana',
    de_DE: 'Немачки',
    dealDate: 'Vreme obrade',
    dealerOperationList: 'Lista operacija dilera',
    dealerOperationQuery: 'Pretraga operacija dilera',
    dealerOperationRecord: 'Zapisi o operacijama distributera',
    dealerStore: 'Prodavnice',
    dealerStoreImportTempateName: 'Šablon za uvoz prodavnica dilera',
    dealerStoreQuery: 'Upit u prodavnici',
    dealers: 'увозник',
    default: 'Направило',
    defaultMap: 'Podrazumevana mapa',
    delete: 'Izbrišete',
    deleteAccountSYNCStep: 'Možete da zatražite brisanje CFMOTO RIDESYNC naloga tako što ćete pratiti ove korake',
    deleteAccountStep: 'Možete da zatražite brisanje CFMOTO RIDE naloga tako što ćete pratiti ove korake',
    deleteDataSYNCStep: 'Možete da zatražite brisanje CFMOTO RIDESYNC podataka tako što ćete pratiti ove korake:',
    deleteDataStep: 'Možete da zatražite brisanje CFMOTO RIDE podataka tako što ćete pratiti ove korake',
    deleteFail: 'Обришање неуспешно',
    deleteFinish: 'Brisanje je završeno',
    deleteKolUserAuthentication: 'Izbriši KOL autentifikaciju korisnika',
    deleteStore: 'Obriši prodavnicu',
    deleteSuccess: 'Успешно удање',
    deleteTip: 'Jeste li sigurni da želite izbrisati ovaj post? Jednom izbrisani podaci se ne mogu vratiti',
    deleteVersionWarn: 'Да ли да избришете овај запис о верзији',
    deleteVideo: 'Желите ли да избришете овај видео?',
    detailAddress: 'Detaljna adresa',
    details: 'Detalji',
    determine: 'Siguran',
    deviceCodeGet: 'Dobiti kod uređaja:',
    deviceContent:
      'Elektronski prihvatnik ograde (nazvan: ključ) kodiranje opreme je niz 10 cifra kodova Kod opreme, QR kod i CE znak su štampani na srebrnom PVC samostalnom štapovu Ima ukupno tri etikete, jedan je popravljen na tijelo vozila (morate podići šipku za posmatranje sjedišta); Druga dvojica su postavljene u vreću za pristup vozilima (Preporučuje se da korisnici dodaju etiketu ručniku vozila ili daljinskoj kontroli)\nMolim vas, pritisnite i sačekajte da otvorite ključ i stavite QR kod na leđa ključa u okvir skeniranja.',
    deviceNo: 'Број повезаног уређаја',
    deviceNumber: 'Број уређаја',
    deviceTitle: 'Проверка кода набора',
    digitalKey: 'дигитални кључ',
    digitalKeyDesc: 'Нема потребе да носите физички кључ, подржава откључавање возила након повезивања преко АПП Блуетоотх (подржано од стране неких модела)',
    directRelease: 'Direktno objavljivanje',
    disagree: 'Sloћila',
    displayNumberDescription: 'Stvarni broj uspešnih prikazivanja na terminalu uređaja nakon što je stiglo obaveštenje (prikazi nakon 5 dana neće biti brojani)',
    displayNumberVolume: 'Broj prikazivanja',
    displayOrder: {},
    displayPicture: {},
    donwloadTemplateDescription: {},
    download: 'Preuzimanje',
    downloadFailFile: 'Preuzmite neuspešnu datoteku',
    downloadSuccessful: 'Преузимање успешно',
    downloadTemplate: 'Preuzmi predložak',
    downloading: 'Preuzimanje...',
    ebookChoice: {},
    ebookEmpty: {},
    ebookPlaceholder: {},
    ebookSwitch: {},
    ebookTitle: {},
    edit: 'Уредити',
    editAccountDeletExplain: 'Uredi obaveštenje o brisanju naloga',
    editActivity: 'Uređivanje aktivnosti',
    editAppRating: 'Уредите механизам оцењивања',
    editBanner: 'Uređivanje reklamnog natpisa',
    editDataDeletExplain: 'Uređivanje obaveštenja o brisanju podataka',
    editExhibitionCategory: {},
    editExhibitionSeries: {},
    editFunctionIntro: {},
    editInformation: 'Уредите информације',
    editInformationCategory: 'Уредите категорију информација',
    editInformationContent: 'Уредите садржај информација',
    editKolUserAuthentication: 'Izmeni KOL autentifikaciju korisnika',
    editModelSeries: 'Уредите серију модела',
    editPicture: 'Уреди слику',
    editPushConfiguration: 'Uredite push podešavanja',
    editRemark: 'Редактирај записи',
    editServiceIntroduce: {},
    editShowroomModel: 'Редактирај модели шоутра',
    editSuccess: 'Uspešno uređeno',
    editTime: 'Vreme uređivanja',
    editUnbindingCommitment: {},
    editUser: 'uređivanje korisnika',
    editVehicleModel: 'Уреди модел',
    editVehicleModelCategory: 'Редактирај категорију автомобила',
    effecting: 'Aktiviranje',
    effectiveTime: 'Датум ступања на снагу',
    electricVehicle: 'Električno vozilo',
    email: 'E-mail',
    emailAdress: 'Adresa E-pošte',
    emailAdressTip: 'Beleška:  Ova adresa e-pošte se koristi za kontakt sa klijentima putem e-pošte.  Uverite se da je adresa e-pošte tačna',
    emailContent: 'Садржај е-поште',
    emailImportTemplate: 'Шаблон за увоз адресе е-поште',
    emailImportTemplateToDownLoad: 'Адресе е-поште се могу увести у групама, кликните за преузимање',
    emailList: 'Листа е-поште',
    emailManage: 'Управљање е-поштом',
    emailMass: 'Емаил Бласт',
    emailSearch: 'Е-маил упит',
    emailSendTip1: 'Note: Be sure to add the note in blue font below at the end of your email. If the text of your email is not in English, please translate it into the language you are using before adding it.',
    emailSendTip2: 'If you want to unsubscribe from such emails, go to the CFMOTO RIDE App, click the [Me] > [Settings] > [Message notification] to turn off the [Receive email marketing] function.',
    emailSendTip3: '*Emails without added notes will not be reviewed and approved.',
    emailText: 'Емаил',
    emailTitle: 'Предмет',
    en_US: 'енглески језик',
    enableStatus: 'Статус омогућен',
    enabled: 'омогућити',
    endTime: 'Vreme završetka',
    endTimeLargeStartTime: 'Vreme završetka mora biti kasnije od vremena početka',
    enterAnswer: {},
    enterCategory: {},
    enterCodeToSafeAccount: 'Da biste osigurali bezbednost naloga, molimo potvrdite svoje podatke o računu koje želite da izbrišete i unesite lozinku ili verifikacioni kôd da biste proverili identitet.',
    enterCodeToSafeData: 'Da biste osigurali bezbednost informacija, molimo potvrdite svoje podatke o računu i unesite lozinku ili verifikacioni kôd da biste proverili identitet.',
    enterIntroduceText: {},
    enterLink: {},
    enterPopupTitle: {},
    enterQueryConditionLookData: 'Након уноса услова упита, можете погледати податке',
    enterQuestion: {},
    enterQuestionAndAnswer: {},
    enterSureUrl: {},
    enterTypeOfLanguage: {},
    enterUnbindingCommitment: {},
    entrance: {},
    errorLatAndLon: 'Longitude and latitude format error, please check',
    errorLocation: {},
    es_ES: 'Шпански',
    estimatedTime: 'Оценено време',
    everySet: 'По поставци',
    examineResultMessage: 'Проверићемо материјале за пријаву што је пре могуће, обратите пажњу на траку са обавештењима или АПП центар за поруке на време.',
    example: 'example',
    exhibition: {},
    exhibitionCategory: {},
    exhibitionCategoryList: {},
    exhibitionCategorySearch: {},
    exhibitionSeries: {},
    exhibitionSeriesList: {},
    exhibitionSeriesSearch: {},
    exportContent: 'Izvoz sadržaja',
    exportExcel: 'Eksportiraj na EXCEL',
    exportLengthExceedOfMonth: 'Дужина износа не превишава% месеци',
    externalLink: 'Spoljna veza',
    failed: 'Неуспешно',
    failedToPreview: 'Преглед није успео',
    feedBackResut: 'Feedback results',
    feedBackTime: 'Vrijeme povratka',
    feedBackVechle: 'Vozilo za povratak',
    feedbackAppQuestion: 'Molim vas, opisite detaljno vrijeme događaja, APP verzije, model mobilnog telefona, putem operacije i opis problema kako bi brzo pomogli pronaći i zabrinuti problem!',
    feedbackDetails: 'Detalji povratka',
    feedbackGuideDesc: 'За више информација, контактирајте нас путем канала за повратне информације у наставку',
    feedbackLabelFileList: 'Molim vas, dodajte slike',
    feedbackMapQuestion: {},
    feedbackMessageSubmitError: 'Vraæanje nije uspjelo',
    feedbackOtherQuestion: 'Molim vas opisite vrijeme događaja, putem operacije i opis problema',
    feedbackReceived: 'Primljena povratka',
    feedbackRecord: 'Zapisi sa povratnim informacijama',
    feedbackRulesFileListMaxSize: 'Превише је изношен фајл',
    feedbackRulesFileListOverType: 'Неподкрепан формат',
    feedbackSubmitTip: 'Ако имате било каквих питања или коментара, такође можете контактирати ЦФМОТО Мекицо Центар за корисничку подршку директно преко ВхатсАпп-а (+52 18115286003) или е-поште (сервициоалцлиент@цфмото.цом.мк)',
    feedbackSuggest: 'Dobrodošli dati vrijedne predloge, ozbiljno ćemo razmotriti vaše ideje.',
    feedbackSupplement: 'Додајте опис проблема',
    feedbackText: 'Vraćanje',
    feedbackType: 'Тип повратне информације (један избор)',
    feedbackVehicleQuestion: 'Molim vas opisite vrijeme događaja, putem operacije i opis problema',
    female: 'Žena',
    fileCountExceed: 'Broj datoteka preko granice',
    fileSizeExceed: 'Величина датотеке премашује ограничење',
    fileUploadingPleaceWait: 'Фајл се отпрема, сачекајте',
    finalOperator: {},
    firstMenu: 'Prvi meni nivoa',
    forcedUpgrade: 'Принудно ажурирање',
    forgetPassword: 'Zaboravi lozinku.',
    fourCarOfNumber: 'Broj korisnika četvorotočkaša',
    fourWheel: 'Four wheeled motorcycles',
    fourWheelConfig: {},
    fourWheeler: 'Четвороточкаш',
    fourWheelerMostClicks: 'Modeli četvorotočkaša sa najviše klikova',
    fourWheelowner: {},
    fr_FR: 'Француски',
    frankfurt: 'франкфурт',
    friday: 'Piątek',
    fuctionIntro: {},
    fullscreen: 'Puni ekran',
    funServiceIntro: {},
    function: 'Function',
    functionConfiguration: {},
    functionConfigureTip: 'Ova funkcija je dostupna samo za konfigurisana vozila pod uvoznikom ili korisničkim imenom u toj zemlji',
    functionDescription: {},
    functionDetail: {},
    functionIntroduce: 'Опис функције',
    functionSetting: {},
    functionalOverview: 'Pregled funkcija',
    galleryEntrance: 'Улаз у галерију',
    galleryEntranceUploadRules: 'Potrebna za formiranje: jpg/jpeg/png, preporu č ena odnosa 4:3, veli č ina ne preko 5MB',
    gender: 'Seks',
    generalAlarm: 'General alarm',
    geofence: 'Elektronska Ograda',
    getCarPosition: 'Добијте локацију возила на време',
    getCode: 'Poљalji',
    goCustomPage: 'Idite na prilagođenu stranicu',
    goOffline: 'Vanmrežne',
    goOnline: 'Online',
    goUrlLink: 'Idite na URL vezu',
    groupTrail: {},
    groupTrailConfig: {},
    guest: 'Nema kola',
    haveTwo: 'Oboje su dostupne.',
    havedWrite: 'Попуњен',
    havedWriteAll: 'попуњен',
    havedWriteAllOrEmpty: 'попуњено или празно',
    helpAndFeedback: 'Pomoæ & Vraćanje',
    helpCenter: 'Центар за помоћ',
    helpMessageHistoryDelete: 'Izbrisati sve zapise pretrage?',
    helpful: {},
    hint: 'Наговестити',
    historyDelete: 'Izbrisati sve zapise pretrage?',
    home: 'Domaća stranica',
    homePage: 'Лична домашна страница',
    hour: 'Сат',
    hoursAgo: 'prije %s sati',
    iWantEnableStoreUserQuery: 'Želim da omogućim pretragu korisnika prodavnice',
    iWantToPostStatistics: 'Želim da objavim statistiku',
    identification: 'Identifikacija',
    identificationText: 'Identifikacija',
    imageSizeExceed: 'Molim vas, upletejte sliku s a širinom i visinom %s',
    imageUploadFailed: 'Укачање фотографије неуспело',
    immediateSend: 'Пошаљи одмах',
    imporFailedOfTableHeader: 'Uvoz nije uspeo. Zaglavlje datoteke se ne podudara',
    import: 'Uvoz',
    importDetails: 'Detalji pitanja',
    importExcel: 'Импортите EXCEL',
    importFail: 'Uvoz nije uspeo',
    importStatus: 'Status uvoza',
    importSuccessful: 'Uvezi uspešno',
    importTemplate: 'Uvoz preuzimanja predloška',
    importer: 'увозник',
    importerAccountOperationRecord: 'Operacije i zapisi prijavljivanja uvoznog naloga',
    importerAvatar: 'Avatar uvoznika',
    importerDisplayName: 'Prikazano ime uvoznika',
    importerEnquiry: 'Upit uvoznika\n',
    importing: 'Uvozi se...',
    inProcess: 'противмере',
    inProgress: 'u nastajanju',
    individualCenter: 'Individualni centar',
    informationCategory: 'Категорија информација',
    informationCategoryList: 'Списак категорија информација',
    informationCategoryQuery: 'Упит за категорију информација',
    informationContent: 'Информативни садржај',
    informationContentList: 'Листа садржаја информација',
    informationCotnentQuery: 'Упит за садржај информација',
    informationCover: 'Информационна покрива',
    informationDetails: 'Информационни подробности',
    informationImage: 'насловна слика',
    informationManagement: 'Управа информацијаName',
    informationTitle: 'Назив информације',
    informer: 'Zviždač',
    informerId: 'ID zviždača',
    initialPassword: 'Иначална парола',
    inputAgreementContent: 'Унесите садржај уговора',
    inputErrorEmoji: 'Ne ulazi emoji',
    installDeviceYouCan: 'Zainstalowanie tego urządzenia umożliwia',
    installVehicleModelAdd: 'Додај описание модела повторених автомобила',
    installVehicleModelDescription: 'Описане повтореног модела',
    installVehicleModelEdit: 'Редактирај описание повторног модела автомобила',
    instrumentLastedVersion: 'TFT prikaz ne mora da se unaprijedi',
    instrumentupgrade: 'TFT prikazivanje',
    intelligentInternetServiceIntroduction: 'Увод у услугу',
    introText: {},
    introduction: 'Увод',
    invalidVercode: 'Неважећи верификациони код',
    iovNotice1: 'Горе наведене функције заснивају се на уређају за умрежавање возила (Т-кутија), молимо вас да се обратите локалном продавцу да бисте купили и инсталирали',
    iovNotice2: 'Горе наведене функције су различите према конфигурацији сваког модела и региона у којем се налази.За детаље се обратите локалном продавцу.',
    iovNotice3: 'Молимо вас да унапред сачувате и забележите број уређаја који је потребан приликом везивања уређаја. Након завршетка повезивања и инсталације, можете искусити више функција',
    isHelpful: 'Da li to pomaže?',
    isStop: {},
    isSupportedChildOwnerOffMapDown: {},
    isSupportedNoOwnerOffMapDown: {},
    isSupportedOffMapDown: {},
    it_IT: 'Италијан',
    iterativeVehicleFunctions: 'Главни делови возила могу се даљински надоградити на мрежи да континуирано понављају функције возила',
    jumpSettings: 'Подешавања скока',
    jumpTarget: {},
    jumpToWeb: {},
    jumpUrl: {},
    justNow: 'Samo sada',
    kolUserList: 'Lista KOL korisnika',
    kolUserManagement: 'Upravljanje KOL korisnicima',
    kolUserQuery: 'Upit KOL korisnika',
    language: 'Jezik',
    language1: 'Relevantni jezici',
    languages: 'Jezik',
    lastLoginTime: 'Vreme poslednjeg prijavljivanja',
    lastModifiedBy: 'Upravljanje nalogom',
    lastUpdateTime: 'Vreme poslednjeg ažuriranja',
    latitude: 'širina',
    launchActivity: 'Pokretanje aktivnosti',
    likeNumber: 'Voli',
    linkAddress: {},
    linkUrlDescription: {},
    listDisplayImages: 'Приказ листе',
    listOfImporters: 'Lista uvoznika',
    listOfQuestion: {},
    listShowStoreCoverPic: 'Popis prikaza slika za pokrivanje trgovine',
    loadSuccess: 'Учитавање комплетно',
    loading: 'Влађавање',
    locationFail: {},
    log: 'Регистр',
    login: 'Уђи',
    loginCountry: 'Земља/регија за пријаву',
    logout: 'Изключи',
    longitude: 'longitude',
    loosing: 'Освежавајуће податке...',
    lowCompatibleVersion: 'Минимална компатибилна верзија',
    mail: 'E-mail',
    male: 'Muškarac',
    manualReviewStatus: 'Статус ручног прегледа',
    mapManage: {},
    marketDataOfdealerStores: 'Tržišni podaci prodavnica distributera',
    masteringCyclingData: 'Мастер јахачки подаци',
    maximum: 'Maks.',
    maximumBannerCountTip: 'Maksimalno %s banera može biti istovremeno online. Molimo uklonite barem jednu prvu.',
    maximumValue: 'Највиша цена',
    menuFunctionName: 'Име функције менија',
    menuIcon: 'Ико меню',
    messagePush: 'Push poruka',
    messagePushDeleteAsk: 'Da li ste sigurni da želite da obrišete ovaj push?',
    messagePushDownloadTemplate: 'Molimo vas da prvo preuzmete šablon, a zatim otpremite datoteku nakon što popunite šablon. Veličina datoteke je ograničena na 2M. Ako podnošenje ne uspe, molimo vas da na odgovarajući način smanjite sadržaj',
    messageWithdrawAsk: 'Želite li da povučete ovaj push?',
    middle: 'средњи',
    min: 'Min',
    minAgo: 'prije %s minuta',
    minimum: 'Min.',
    minimumValue: 'Minimalna vrijednost',
    modelDetail: 'Детаљи модела',
    modifyFail: 'Измена неуспела',
    modifyPassword: 'Измени паролу',
    modifySuccess: 'Успешно изменение',
    monday: 'Poniedziałek',
    more4pic1video: 'Do 4 slika/1 video',
    morning: 'Rano',
    motorcycle: 'Dva volana motora',
    moveDown: 'Pomešati se nadol',
    moveLongPressMap: {},
    moveMapSelectPoint: {},
    moveTo: 'Premesti u',
    moveToBottom: 'Premeštanje na dno',
    moveToTop: 'Premeštanje na vrh',
    moveToTopStatus: 'Zakačeno stanje',
    moveTop: 'Gornje postavke',
    moveUp: 'Pomeranje na gore',
    multimedia: 'Multimedijalne',
    mustInteger: {},
    mute1Day: 'Tišina 1 dan',
    mute2Days: 'Tišina 2 dana',
    mute30Days: 'Tišina 30 dana',
    mute3Days: 'Tišina 3 dana',
    mute7Days: 'Tišina 7 dana',
    muting: 'Nem',
    nameOfImporter: 'Uvoznikovo ime',
    navigation: 'Navigacija na mapi',
    nearLoginTime: 'Vreme poslednjeg prijavljivanja',
    needPopup: 'Потребан је искачући прозор',
    negativeNum: 'Лоша рецензија',
    networkException: 'Izuzev mreže',
    newAddFail: 'Додање неуспешно',
    newAddSuccess: 'успешно додато',
    newBanner: 'Novi baneri',
    newCancellationAgreement: 'Novi dogovor o otkazu',
    newFunctionIntro: {},
    newMenuFunction: 'Нова функция меню',
    newModelSeries: 'Нова серија модела',
    newPassword: 'Нова парола',
    newPasswordNotEqual: 'Нова лозинка унета двапут је недоследна, унесите поново',
    newQuestionType: {},
    newStoreNumber: 'Broj novih prodavnica',
    newTopic: 'Nova tema',
    newUnbindingCommitment: {},
    nextStep: 'Sledeæi',
    nickName: 'Nickname',
    no: 'Ne, ne.',
    noContent: 'Nema povezanog sadržaja',
    noContent2: 'Predložite promenu ključnih reči ili',
    noData: 'Нема података',
    noFeedbackRecord: 'Trenutno nema snimka povratka',
    noJump: 'Нема скока',
    noLog: 'Nema dnevnika',
    noNeedPopup: 'Нису потребни искачући прозори',
    noOkToFeedback: 'Non soluta, respondere volo',
    noOwnerScore: 'Оцене невласника',
    noPass: 'Neuspeh',
    noSendPeople: 'Nema pošiljaoca',
    noSupportMapDown: {},
    noThisPermission: 'Нема дозволе за ову операцију',
    noUserSelected: 'Није изабран ниједан корисник, не може да се пошаље',
    nofiledSeviceContent: {},
    nonOwner: 'Nevlasnik',
    nonVehicleOwnerCharged: {},
    none: 'Niko',
    normal: 'Normalno',
    notAllowImageAndVideo: 'Video se ne može odabrati kada birate sliku',
    notAllowed: 'Nije dozvoljeno',
    notBeLessOrEqual: 'Ne manje nego ili jednako',
    notDeleted: 'Nije iskljuèen',
    notDistributedYet: 'Još nije izdana',
    notEnabled: 'Није омогућено',
    notHelpful: {},
    notLessThan: 'Ne manje nego',
    notRecommended: 'Ne preporučuje se',
    notReleasedYet: 'Još nije objavljen',
    notStarted: {},
    notTop: 'Nisam stigao do vrha',
    notice: 'Budi pažljiv',
    noticeText1: 'Dear CFMOTO users,',
    noticeText2:
      'Hello! We sincerely thank you for your continuous support and trust in CFMOTO. We are committed to enhancing service quality and implementing innovative improvements, and we have made business adjustments due to this commitment. As of 08/10/2024, we will discontinue the CFMOTO RIDE App (the "App") in the United States. In its place, we have launched the brand-new CFMOTO RIDESYNC App. We hope you continue to enjoy our services through this new app.',
    noticeText3: 'Important notes:',
    noticeText4: '1. From today on, this app will only be available for bound CFMOTO vehicles in the United States and no longer support binding new vehicles. If you need to bind a new vehicle, please download and use the CFMOTO RIDESYNC App.',
    noticeText5:
      '2. We strongly recommend that you download and use the CFMOTO RIDESYNC App before 08/10/2024 so that you can continue enjoying our services seamlessly. We provide you with a convenient data migration service. You can choose to migrate all data retained in this App to the CFMOTO RIDESYNC App to preserve your personal information, vehicle information and past service records. We will ensure your data security and privacy during the migration process. If you want to use the CFMOTO RIDESYNC App without migrating data, you can re-register with the CFMOTO RIDESYNC App to use the new services. Click on the button below to learn how to download and use the CFMOTO RIDESYNC App.',
    noticeText6:
      '3. Please note that after 08/10/2024, you will no longer be able to use the relevant services of the App in the United States. Meanwhile, we will delete all personal data generated during your use of the App according to the relevant laws and regulations.',
    noticeText7:
      'We are fully aware that this change may cause temporary inconvenience to you, but we believe that with this service upgrade, you will have a richer and more satisfying user experience. If you encounter any issues or have questions during this process, we will always be here to help. Thank you for your understanding and cooperation, and we look forward to serving you in the CFMOTO RIDESYNC App.',
    noticeText8: 'Wish you a happy life!',
    notzero: 'Бројеви верзија не могу сви бити 0',
    offline: 'Offline',
    offlineAlready: 'Vanmrežne',
    offlineTime: 'Vanmrežno vreme',
    offlineTimeMustBeGreaterThan: 'Vanmrežno vreme mora biti veće od',
    ok: 'OK',
    oldPassword: 'Stara lozinka',
    onLineAlready: {},
    oneMonths: 'Mesec',
    oneYear: 'Jedna godina',
    online: 'Онлине',
    onlyFourWheel: 'Operacija samo èetiri runde',
    onlyTwoWheel: 'Operacija samo dve runde',
    openEveryCount: {},
    openEveryDay: {},
    openProductType: {},
    operationRecord: 'Evidencija operacija',
    operationTime: 'Vreme operacija',
    operations: 'Operacije',
    operator: 'Operator',
    opreate: {},
    opreateFunSet: {},
    opreateFunSetAdvert: {},
    opreateFunSetAdvertAdd: {},
    opreateFunSetAdvertEdit: {},
    opreateFunSetAdvertView: {},
    optionalUpgrade: 'Опционо ажурирање',
    orderList: {},
    orderMange: {},
    orderNum: {},
    otaUpgradeVehicle: 'ОТА возило за надоградњу',
    otaUpgradeVehicleDesc: 'Главне компоненте возила могу се даљински надоградити како би се континуирано понављале перформансе возила.',
    other: 'Drugi',
    over: 'nad',
    owner: 'Uzmi auto',
    ownerIdHomepageImage: 'Glavna stranica lične karte, vozačke dozvole ili pasoša koja sadrži lične identifikacione podatke.',
    parameterConfiguration: 'Конфигурација параметара',
    partialImportFailed: 'Delimičan uvoz nije uspeo',
    pass: 'Odobrenje',
    passValidateDeleteAccount: 'Potvrda identiteta je uspešna!  Kliknite na dugme Prosledi zahtev na dnu da biste zatražili brisanje naloga',
    password: 'lozinka',
    passwordRuleText: '8-20 карактера, мора да садржи велика и мала енглеска слова, бројеве, специјалне знакове',
    passwordRules: 'Правила лозинке',
    paySetting: {},
    payStrategy: {},
    peleaseEnterProvince: 'Molim vas, uđite u provinciju/državu',
    pendSend: 'нерешен',
    pending: 'U toku.',
    permanentMuting: 'Trajno isključen',
    phoneModel: 'Model',
    phoneNum: 'telefonski broj',
    phoneNumber: 'Telefonski broj',
    phoneOrEmail: 'Broj telefona/e-mail',
    phoneOrEmailImportTemplate: 'Шаблон за увоз броја мобилног телефона/адресе е-поште',
    phoneOrEmailNotRegistered: 'Broj telefona ili e-mail adresa nije registriran.',
    phoneOrEmailOrUserId: 'Broj mobilnog telefona/e-mail adresa/ID korisnika',
    picture: 'Слика',
    pl_PL: 'Пољски',
    pleaseAddImage: 'Молимо додајте датотеке слика',
    pleaseAddVideoFile: 'Молимо додајте видео датотеке',
    pleaseEnter: 'Унесите',
    pleaseEnterAccountInfo: 'Unesite informacije o računu',
    pleaseEnterAmount: {},
    pleaseEnterCity: 'Please enter the city',
    pleaseEnterEmail: 'Molimo, unesite vašu i-mejl adresu',
    pleaseEnterEmailAdress: 'Unesite adresu e-pošte',
    pleaseEnterIntro: 'Унесите увод',
    pleaseEnterLatAndLong: 'Molim vas, ulazite u dužinu i širinu',
    pleaseEnterNewPassword: 'Уведите нову паролу',
    pleaseEnterPassword: 'Унесите лозинку',
    pleaseEnterPhone: 'Unesite Vaš broj telefona',
    pleaseEnterQuestionDescription: 'Molim vas, uvedite opis problema.',
    pleaseEnterRealname: 'Unesite svoje pravo ime',
    pleaseEnterRemark: 'Молимо унесите напомене',
    pleaseEnterServePhone: 'Molim vas, ulazite broj telefona.',
    pleaseEnterStoreAddressDetail: 'Unesite detaljnu adresu',
    pleaseEnterStoreIntroduce: 'Unesite uvod u prodavnicu',
    pleaseEnterStoreName: 'Unesite naziv prodavnice',
    pleaseEnterStoreRemarkName: 'Unesite naziv napomene prodavnice',
    pleaseEnterTitle: 'Унесите наслов',
    pleaseEnterUsername: 'Unesite korisničko ime',
    pleaseEnterVercode: 'Унесите верцоде',
    pleaseEnterVersion: 'Унесите број верзије',
    pleaseEnterVersionIntroduction: 'Унесите увод у верзију',
    pleaseEnterVideoDetail: 'Унесите детаље о видео снимку',
    pleaseEnterVin: 'Unesite VIN',
    pleaseInputWord: 'Molim vas, uvedite ključnu reè',
    pleaseLoginFirst: 'Molim vas, prijavite se prvi',
    pleaseRepeatNewPassword: 'Поновите нову лозинку',
    pleaseSelect: 'молимо изаберите',
    pleaseSelectBusinessHours: 'Molim vas odaberite poslovne sate',
    pleaseSelectCity: 'Molimo izaberite grad',
    pleaseSelectCountry: 'Molimo izaberite zemlju',
    pleaseSelectCurrency: {},
    pleaseSelectMatchingMultimediaContent: 'Izaberite odgovarajući multimedijalni sadržaj',
    pleaseSelectPayChannel: {},
    pleaseSelectProblemWhere: 'Molim vas izaberite scenarij u kojem se problem dogodio',
    pleaseSelectProducType: {},
    pleaseSelectProvince: 'Molimo izaberite pokrajinu/državu',
    pleaseSelectQueType: 'Please select the type of question',
    pleaseSelectReportReason: 'Molim vas odaberite razlog za izveštaj',
    pleaseSelectStatus: 'Molim vas izaberite status',
    pleaseSelectStoreType: 'Molim vas odaberite tipu trgovine',
    pleaseSelectTimedSendTime: 'Молимо изаберите време слања',
    pleaseSelectUserTheList: 'Izaberite korisnika sa liste',
    pleaseSelectVehicle: 'Молимо изаберите возило',
    pleaseSelectVehicleConfig: {},
    pleaseSelectupgradeType: 'Изаберите метод ажурирања',
    pleaseSureType2: 'Уверите се да је све у',
    pleaseUpload: 'Молим вас напустите',
    pleaseUploadPicVideo: 'Molim vas, dodajte slike/video',
    popUpFrequencyType: 'Форма за искачући прозор',
    popUpFrequencyValue: 'Фреквенција искачућих прозора',
    popUpFrequencyValueValid: 'Изаберите дане учесталости',
    popUpReminder: 'Да ли да се појави подсетник',
    popupArea: 'поп-уп кориснички опсег',
    popupCreate: {},
    popupDayOne: 'Једном по одређеном броју дана',
    popupEdit: {},
    popupFrequency: {},
    popupManagement: {},
    popupOne: {},
    popupPosition: {},
    popupStatus: {},
    popupTarget: {},
    popupTime: {},
    popupTitle: {},
    positiveNum: 'Добре критике',
    postComment: 'Ostavite komentar',
    postContent: 'Sadržaj posta',
    postId: 'Пост ИД',
    postList: 'Spisak objava',
    postManagement: 'Upravljanje objavama',
    postSearch: 'Pretraga posla',
    posts: 'Poruka',
    precautionText1:
      'Hello! As you have learned that we will discontinue the CFMOTO RIDE App (hereinafter referred to as "the App") in the United States from 08/10/2024, to assist you with this change, please take note of the following important matters:',
    precautionText2: '1. From today on, you will not be able to bind a new vehicle through the APP to enjoy relevant vehicle services.',
    precautionText3: '2. To ensure a smooth transition to the new service, we have provided an entry at the top of the vehicle page in this App. You can learn how to download and use the CFMOTO RIDESYNC App at any time through that entry.',
    precautionText4:
      '3. Please note that once the service ceases to take effect, you will no longer be able to enjoy any services of the App in the United States. At the same time, we will delete all personal data generated during your use of the App in accordance with relevant laws and regulations. This means that we will not be able to respond to any of your requests for data after the service is discontinued.',
    precautionText5:
      'We understand that this change may cause inconvenience to you, but we are committed to continuously protecting your data security and privacy. We encourage you to take early action to download and start using the CFMOTO RIDESYNC App in a timely manner so that you can continue to enjoy the quality service provided by CFMOTO. If you have any questions or need assistance in this process, please do not hesitate to contact us. We look forward to serving you in the CFMOTO RIDESYNC App.',
    privacyContent: 'Детаљи о садржају политике приватности',
    privacyPolicy: 'Politika privatnosti',
    privacyPopupAgree: 'Поново прибавите сагласност корисника на политику приватности кроз искачући прозор',
    privacyVersion: 'Верзија политике приватности',
    privacyVersionList: 'Листа верзија политике приватности',
    problemaDes: 'Описане проблема',
    processMethod: 'Metodi obrade',
    processReason: 'Razlog za obradu',
    processReasonDetails: 'Detalji razloga obrade',
    processRecord: 'Obrada zapisa',
    processReport: 'Obrada izveštaja',
    processSolution: 'Machining rešenja',
    processUser: 'Rukovanje korisnicima',
    processed: 'Processed',
    productDetails: {},
    productTime: 'vreme proizvodnje',
    prohibitDecimalsAndNegative: {},
    pt_PT: 'португалски',
    publishInformation: 'Објавите информације',
    publishPosts: 'Objavljivanje objave',
    pullBefore: 'Спустите се да освежите.',
    pulling: 'Ослобађање освежавање сада',
    purchaseAndInstall: 'Купите и инсталирајте',
    pushConfiguration: 'Push podešavanja',
    pushContent: 'Пусх садржај',
    pushList: 'Lista push obaveštenja',
    pushMode: 'Režim push obaveštenja',
    pushNow: 'Pošaljite push obaveštenje sada',
    pushQuery: 'Upit push obaveštenja',
    pushRecord: 'Evidencija push obaveštenja',
    pushScope: 'Opseg push obaveštenja',
    pushTime: 'Vreme slanja push obaveštenja',
    pushTimeDifferenceAsk: 'Време слања које одаберете може довести до тога да неки корисници не буду у могућности да приме овај пусх због временских разлика. Да ли сте сигурни да желите да сачувате?',
    pushTitle: 'Naslov push obaveštenja',
    pushed: 'Gurnuo',
    pushing: 'Slanje push obaveštenja',
    query: 'Тражи',
    question: {},
    questionInquiry: {},
    questionType: 'Tip problema',
    questionTypeList: {},
    questionTypeTemplate: {},
    quickRelease: 'Brzo oslobađanje',
    ranking: 'Rangiranje',
    ratingWarn1: 'За кориснике власника возила, контрола паметне услуге која одговара земљи/региону у позадини управљања није укључена или услуга паметне услуге није истекла након укључивања. Возило је на мрежи и има',
    ratingWarn2: 'или више комплетних записа о вожњи (почетак и крај сваке вожње су пријављени догађај), искачући прозор ће се појавити када корисник изађе из Ми Цицлинг и врати се на почетну страницу.',
    reUpgrade: 'Ponovi',
    readAgree: 'Pročitajte i složite se sa',
    readAndAgree: 'Molim vas pročitajte i složite se',
    readAndAgreeTo: 'Pročitao sam i slažem se sa',
    readDeleteStep: 'saznajte više o tipovima podataka koje ćemo izbrisati ili zadržati, kao i o bilo kojim drugim periodima zadržavanja',
    realname: 'Pravo ime',
    reasonForReport: 'Razlog za izveštaj',
    receiveCarReminderMessage: 'Примите упозорења о поруци возила',
    rechargeAmount: {},
    rechargeChannel: {},
    rechargeStatus: {},
    rechargeTime: {},
    recharged: {},
    recipients: 'Прималац',
    recipientsNum: 'Обим примаоца',
    recommended: 'Preporuиujem',
    recommendedStatus: 'Preporučeni status',
    redirectUrl: {},
    refreshInterval: 'Interval osvežavanja',
    refreshSend: 'ponovo poslati',
    refundFailed: {},
    refunded: {},
    refunding: {},
    refused: 'Odbiti',
    registerDate: 'Vreme registracije',
    rejected: 'Odbijeno.',
    releaseContent: 'Objavljivanje sadržaja',
    releaseMute: 'Oslobodi tišinu',
    releaseTime: 'Vreme izdavanja:',
    released: 'Oslobodi',
    releasedBy: 'Izdavača',
    remark: 'Note',
    rememberPassword: 'Zapamti šifru',
    reminder: 'Podsetnik',
    remove: 'Izbrišete',
    removeOnlinUpgrade: 'Даљинско возило за надоградњу на мрежи',
    repeatNewPassword: 'Ponavljam novu lozinku.',
    replaceTBOX: 'Замени TBOX',
    replied: 'Odgovor',
    reply: 'Odgovoriti',
    report: 'Izvještaj',
    reportList: 'Izvještajna lista',
    reportManagement: 'Upravljanje izveštajima',
    reportReason: 'Razlog za izveštavanje',
    reportReasonDetails: 'Detalji razloga izveštaja',
    reportReasonPlaceholder: 'Napišite sadržaj koji želite prijaviti, 0-1500 reči',
    reportSearch: 'Pretraživanje izveštaja',
    reportSuccessful: 'Izvještaj uspešno, sredićemo to što je pre moguće.',
    reportTime: 'Vreme izveštaja',
    reportType: 'Tip izveštaja',
    reportedContent: 'Sadržaj izveštaja',
    reportedUser: 'Izveštavanje korisnika',
    reportedUserId: 'Korisnički ID izveštaja',
    requestTimedOut: 'Vreme zahteva je odmišljeno',
    reset: 'Poništi',
    return: 'Povratak',
    review: 'Преглед',
    reviewApproved: 'Преглед је прошао',
    richText: {},
    ro_RO: 'румунски',
    roleDescription: 'Опис роли',
    roleName: 'Име роли',
    rolePermission: 'Dozvoljavanje uloge',
    'routerTitleBinding-agreement': '绑车协议',
    routerTitleDownload: 'CFMOTO RIDE APP Download',
    routerTitleEbook: 'ebook',
    routerTitleIntroduce: '介绍',
    routerTitleOrderConfirm: 'Order Confirmation',
    routerTitlePdf: 'PDF',
    ru_RU: 'Руски',
    safeRemind: 'Da biste zaštitili sigurnost vašeg računa, molim vas, ne podajte osjetljive osobne informacije ovde, kao što je lozinka, itd.',
    satelliteMap: 'Satelitska mapa',
    saturday: 'Sobota',
    save: 'Спаси',
    saveAndPreview: 'Сачувајте и прегледајте',
    saveFail: 'Sačuvaj nije uspeo',
    savePicture: 'Сачувај слику',
    saveSettings: 'Сачувај подешавања',
    saveSuccess: 'Uspešno sačuvan',
    saveVideo: 'Сачувај видео',
    scanQrcodePreview: 'Скенирајте КР код испод са својим мобилним телефоном да бисте га прегледали',
    screenNavigationGuidance: 'Uputstva za instalaciju',
    sdkStatement: 'SDK izjava',
    search: 'Тражи',
    searchRecords: 'Historijska pretraga',
    secondaryMenu: 'Sekundarni menu',
    securityMessage: 'Gornje informacije se koriste samo u svrhu provere identiteta, CFMOTO čuva vaše podatke.',
    select: 'Izaberite',
    selectAll: 'Select all',
    selectAuthentication: 'Izaberi autentifikaciju',
    selectChannelType: 'Изаберите канал за повратне информације',
    selectCountry: 'Odaberi zemlju',
    selectData: 'Izaberite podatke koje želite da izbrišete i kliknite na dugme Prosledi na dnu da biste prosledili zahtev za brisanje podataka.',
    selectDate: 'Изаберите Датум',
    selectEnableStatus: {},
    selectFeedBackState: 'Изаберите статус обраде повратних информација',
    selectFeedbackType: 'Изаберите тип повратних информација',
    selectJumpTarget: {},
    selectLanguage: 'Izaberite jezik',
    selectOneCarType: 'Изаберите најмање један модел',
    selectPoint: {},
    selectPopupFrequency: {},
    selectPopupPosition: {},
    selectPopupTarget: {},
    selectPopupTime: {},
    selectRejectReason: 'Izaberite razlog odbijanja',
    selectTheLanguage: 'Izaberi jezik',
    selectTime: 'izaberite vreme',
    selectUser: 'Изаберите кориснике',
    selectVehicle: 'Izaberi vozilo',
    selectionOfImporter: 'Izbor uvoznika',
    sendNumberDescription: 'Među efikasnim ciljnim uređajima, server Aurora zapravo uspešno kreira broj uređaja za slanje zadataka',
    sendNumberVolume: 'Broj slanja',
    sendType: 'Режим слања',
    sendUserNum: 'Broj slanja',
    sending: 'У слању',
    serial: 'Ne, ne.',
    seriesBackground: {},
    seriesDesc: {},
    seriesIntroduction: 'Uvedenje serije',
    seriesName: {},
    seriesShowcase: 'serija Диаграм показа',
    seriesUplodImgRule: {},
    seriousAlarm: 'Ozbiljni alarm',
    serviceIntroduction: 'Увод у услугу',
    serviceText: 'Usluga',
    settingSuccess: 'Постанови успешно',
    shareNumber: 'Broj dionica',
    sheet: 'Zhang',
    show: 'Погледајте',
    showPicturesOfVideos: 'Прикажи слике/видео снимке',
    showroomModel: 'Modeli emisije',
    showroomModelList: 'Листа модела изложбеног салона',
    showroomModelQuery: 'Упит за модел изложбеног салона',
    showroomUploadRules: 'The image format requirement is jpg/jpeg/png, the image ratio is 9:19.5, the size does not exceed 5MB, and the video size does not exceed 50MB',
    signOut: 'Automatski prekid radnog odnosa',
    singapore: 'Сингапур',
    sixMonths: 'Šest meseci',
    slideToRight: 'prevucite udesno',
    smartServices: 'Паметна услуга',
    someUser: 'Neki korisnici',
    sort: 'Vrsta',
    source: 'Izvor podataka',
    sr_YU: 'Српски',
    startChecking: 'Poèni provjeriti',
    startTime: 'Početno vreme',
    statisticalTime: 'Vreme statistike',
    status: 'Država',
    stepText1: 'To ensure smooth data migration and use of the CFMOTO RIDESYNC App, we recommend that you follow these steps:',
    stepText2: '1. First, you can click the button below [Download CFMOTO RIDESYNC] or directly open Apple Store/Google Play to search and download CFMOTO RIDESYNC App;',
    stepText3: '2. After downloading and installing, please open the CFMOTO RIDESYNC App to enter the login page. On this page, you need to log in with your existing CFMOTO RIDE account and password;',
    stepText4:
      '3. When you enter your account and password correctly, the App will pop up a prompt window asking whether to start the data migration. When you click OK, the data migration starts immediately and this process is uninterrupted. If you select "Cancel" in this step, you will not be able to continue logging into the App.',
    stepText5: '4. After clicking OK, the data migration will start immediately, and the process is uninterruptable. If that fails, contact it@cfmoto.com',
    stepText6:
      '5. After the data migration is completed, you will automatically enter the vehicle homepage of the CFMOTO RIDESYNC App. At this moment, you can start to use all functions of the App normally, and you will be able to access all the data you previously retained in the CFMOTO RIDE App.',
    stepText7:
      '*Important notes: Be sure to log in the CFMOTO RIDESYNC App with your CFMOTO RIDE account to ensure successful data migration. If you choose to register a new account or log in with another account, your data will not be migrated. In addition, after successful data migration, your original CFMOTO RIDE account will no longer support login to the CFMOTO RIDE App. Please operate carefully to ensure the safe migration of your data.',
    stop: {},
    store: {},
    storeAddressCountryTip: 'Beleška:  Ova adresa prodavnice je jedina osnova da vas korisnici pronađu.  Pažljivo popunite da biste bili sigurni da je adresa tačna',
    storeAddressDetail: 'Adresa prodavnice',
    storeAddressDetailTip: 'Primer : detaljna adresa: NO.116, Wuzhou Road, Yuhang Economic Development Zone, Hangzhou',
    storeAddressPosition: 'Širine i dužine',
    storeAddressPositionTip: 'Longitude: Longitude has integer parts ranging from -180 to 180, and decimal parts up to 15 decimal places\nLatitude: The integer part of the latitude is -90~90, and the decimal part is no more than 15 decimal places',
    storeBusinessType: 'Tip prodavnice',
    storeImage: 'Slika skladišta',
    storeImportTemplateText: 'Molimo preuzmite šablon, popunite informacije o prodavnici dilera u datoteci šablona, a zatim otpremite datoteku; veličina datoteke je ograničena na 1 MB; ako slanje ne uspe, smanjite sadržaj ili ga otpremite u serijama',
    storeIntroduce: 'Uvod u prodavnicu',
    storeList: 'Lista prodavnica',
    storeMange: 'Управа магазина',
    storeName: 'Ime prodavnice',
    storeNameTip: 'Beleška:  Izaberite jezik koji sistem podržava da biste uneli naziv prodavnice',
    storeQueryUserStatistics: 'Statistika korisničkih upita za prodavnice',
    storeRemarkName: 'Ime napomene prodavnice',
    storeRemarkNameTip: 'Beleška:  Ako jezik koji sistem podržava ne zadovoljava vaše potrebe, ovde možete uneti naziv napomene prodavnice na jeziku koji želite.',
    storeSearch: 'Upit za prodavnice',
    storeServicePhone: 'Broj telefona servisa',
    storeServicePhoneTip: 'Beleška:  Ovaj broj se koristi za telefonski kontakt klijenta, uverite se da je broj telefona tačan.',
    storeServiceTime: 'Radno vreme',
    storeStatistics: 'Statistika prodavnice',
    storeUploadImageRequire:
      'The image format requirement is jpg/jpeg/png. It is recommended that the size of a single image should not exceed 5MB, and a maximum of 9 images can be imported at a time. Multiple imports are allowed, and the total number should not exceed 9 images',
    storefront: 'Prodavnica',
    submissionFailed: 'Slanje nije uspelo, molimo pokušajte ponovo.',
    submit: 'Подај',
    submitAccountDeleteApply: 'Prosleđivanje zahteva za brisanje naloga',
    submitDataDeleteApply: 'Prosleđivanje zahteva za brisanje podataka',
    submitFeedback: 'Pošaljite povratne informacije',
    submitted: 'Poslano',
    successful: 'Uspješno',
    sunday: 'Niedziela',
    supportMapDown: {},
    supportedChannel: {},
    sureAgree: 'Slažete se ili ne?',
    sureBackApply: 'Potvrdite povlačenje aplikacije za brisanje računa',
    sureDelete: 'Једном избрисан, не може се вратити. Да ли сте сигурни да желите да је избришете',
    sureDeleteData: 'Želite li zaista da izbrišete izabrane podatke?  Kada se potvrde, podaci će biti odmah izbrisani i ne mogu se spaseni',
    sureDeleteSeries: {},
    sureDeleteSetting: {},
    sureDeleteStoreInfo: 'Jeste li sigurni da obrišete ove informacije o trgovini? Nakon izbrisanja, informacija neće biti oporavila',
    sureReject: 'Jeste li sigurni da odbijate?',
    sureSuspend: 'Слање ће се зауставити након завршетка. Да ли сте сигурни да желите да раскинете',
    suspend: 'Прекини',
    sv_SE: 'Шведски',
    switchLanguage: 'Zamenite jezik',
    system: 'Sistem',
    systemBusy: 'Sistem je zauzet, pokušajte ponovo kasnije',
    systemVersion: 'верзија система',
    tboxIntro: 'Т-Бок је кључни уређај за реализацију функције интелигентне мрежне везе возила',
    teamConfigTip: {},
    threeMonths: 'Tri meseca',
    thursday: 'Czwartek',
    time: 'Vrijeme',
    timeSend: 'Временско слање',
    timedOffline: 'Planirano van mreže',
    timedPush: 'Vremenski odreðeno push obaveštenje',
    timedRelease: 'Vremensko puštanje',
    timedSendTime: 'Пошаљи време',
    tips: 'Погрешки',
    title: 'titula',
    to: 'Ka',
    toBeReleased: 'Uskoro stižem',
    topMenu: 'Нагорни меню',
    topicContent: 'Sadržaj teme',
    topicList: 'Lista tema',
    topicManagement: 'Upravljanje temama',
    topicSearch: 'Pretraga teme',
    topicTitle: 'Naslov teme',
    totalAndlLayoutOfStores: 'Ukupan broj i raspored prodavnica',
    totalClicks: {},
    totalNumber: 'Ukupan broj puta',
    tr_TR: 'турски',
    triggerNum: 'Број окидача',
    tuesday: 'Wtorek',
    turnOn: 'Otvaranje',
    twoCarAndFourCarOfNumber: 'Broj korisnika dvo- i četvorotočkaša',
    twoCarOfNumber: 'Broj korisnika dvotočkaša',
    twoWheelConfig: {},
    twoWheeler: 'Двоточкаш',
    twoWheelerAndFourWheeler: 'Dvotočkaša i četvorotočkaša',
    twoWheelerMostClicks: 'Modeli dvotočkaša sa najviše klikova',
    twoWheelowner: {},
    typeMessage: 'тип повратне информације',
    types: 'Тип',
    unbind: 'Nevezana',
    unbindingCommitment: {},
    unbindingLabelRealName: 'Ваше име и презиме',
    unbound: 'Odpovezan.',
    understandRealtimeConditions: 'Примајте вибрације возила и електронске поруке подсетника за улазак и излазак из возила и разумејте статус возила у реалном времену',
    uninstallTboxDesc: 'За возила која немају инсталиран Т-Бок, можете видети основне информације о возилу као што су број рама, број мотора и електронско упутство након везивања.',
    unitCurrencyPer: {},
    unitMonth: 'Месец',
    unlimited: 'Neograničen',
    unpaid: {},
    unprocessed: 'Nestvoreno',
    unresolved: 'Još uvek ne možete da rešite? Kliknite',
    unspecified: 'Povjerljivost',
    upToTopics: 'Možete dodati u %s teme',
    updateAuthenticationTime: 'Ažuriraj vreme autentifikacije',
    updateBy: 'Ažuriranje programa',
    updateSuccess: {},
    updateTime: 'Време ажурирања',
    updating: 'Ažuriranje',
    upgradeAgainDescription: 'Upgrade zadatak je ponovo guran. Molim vas, pratite „Vodič“, na vrhu trenutne stranice da povežete mrežu tft ekrana da bi se poboljšala.',
    upgradeAssistant: 'Pomoć',
    upgradeDescription: 'Kada se naðe nova verzija, molim vas pratite „Vodič“, na vrhu trenutne stranice da povežete mrežu tft display za unaprjeđenje.',
    upgradeSuccessful: 'Nadogradnja je uspešna',
    upgradeType: 'Метод ажурирања',
    upload: 'Отпремити',
    uploadDisplayPicture: {},
    uploadFail: 'Otpremanje nije uspelo',
    uploadFailed: 'Отпремање није успело, покушајте на другој мрежи',
    uploadFailedOfTry: 'Уплата не успела, молим те опитајте отново',
    uploadFileMore1M: 'Величина датотеке за отпремање не прелази 1М',
    uploadFiles: 'Пошаљите датотеку',
    uploadImageRules1To1: 'Format slike mora biti jpg/jpeg/png, sa odnosima 1:1 slike i maksimalnom veličinom 5MB',
    uploadLog: 'Одхвати журнал',
    uploadPicture: 'Otpremi sliku',
    uploadQuantityExceed: 'Količina postavljanja prelazi granicu',
    uploadSuccessful: 'Успешно нагруђане',
    uploadTime: 'Vreme otpremanja',
    uploadTip556_740: {},
    uploadVideoRules: 'Подржано је само једно отпремање видео датотека. Препоручује се да величина једног видео снимка не прелази 50 МБ.',
    uploadVideoRules4To3: 'Podrška video formata, preporučeni odnos od 4:3, veličina ne preko 50MB',
    urlLink: 'URL veza',
    user: 'Korisnik',
    userEmail: 'E-mail',
    userGender: 'Pol korisnika',
    userId: 'ID korisnika',
    userIdTemplate: 'Шаблон за увоз корисничког ИД-а',
    userIdentity: 'Идентификатор',
    userLocalTime: 'Локално време корисника',
    userLogin: 'Prijava',
    userMobilePhone: 'Broj mobitela',
    userModel: 'Korisnički model',
    userName: 'Korisničko ime',
    userName1: {},
    userNickname: 'Надимак корисника',
    userNum: 'Број корисника',
    userPhone: 'Broj mobilnog telefona',
    userRealName: 'Korisničko pravo ime',
    userReply: 'Odgovor korisnika na čekanju',
    userStatus: 'Status korisnika',
    userType: 'Tip korisnika',
    userUnbind: 'Полицај се не врши',
    users: 'корисника',
    vacationTime: 'Vreme odmora',
    validNumberVolume: 'Broj važećih ciljeva',
    validNumerDescription: 'Ciljana grupa odabrana zadatkom push obaveštenja I brojem ciljnih uređaja nakon procesa efikasnosti',
    validateEmail: 'Format adrese elektronske pošte je pogrešan, molim proverite.',
    validateImageRadio: 'Zahtevi formata datoteke slike:  %s, odnos slika:  %s, ne više od %s',
    validateImageSize: 'Zahtevi formata datoteke slike:  %s, preporučena veličina slike:  %s, ne više od %s',
    validatePhone: 'Greška u formatu telefonskog broja, proverite',
    validateVideo: 'Zahtevi za format video datoteke:  %s, ne više od %s',
    validateVin: 'Pogrešan VIN, molim proverite.',
    vehicleAlarmDetails: 'Detalji alarma vozila',
    vehicleBindDuration: 'Trajanje povezivanja vozila',
    vehicleBrochure: 'Брошура возила',
    vehicleColor: 'Боја возила',
    vehicleDetails: 'Detalji o vozilu',
    vehicleDrivingLicense: 'Potvrda o registraciji vozila.',
    vehicleFaultDetails: 'Detalji o kvaru vozila',
    vehicleGallery: 'Галерија возила',
    vehicleGalleryEntranceConfiguration: 'АПП страница изложбеног салона мотоцикала и улазне слике функције галерије возила су преузете из следеће конфигурације. Уверите се да су три слике попуњене у конфигурацији.',
    vehicleGalleryEntranceSettings: 'Подешавања улаза у галерију возила',
    vehicleGalleryUploadRules: 'Potrebna je za format slika jpg/jpeg/png. Preporučuje se da veličina jednog slika ne prelazi 5 MB, a maksimalno od 10 slika može biti uvezana u jedno vrijeme. Dozvoljeno je višestruko uvoza',
    vehicleIdHomepageImage: 'Glavna stranica potvrde o registraciji vozila sa imenom vlasnika i brojem šasije (VIN).',
    vehicleModel: 'Model vozila',
    vehicleModelAlbum: 'Албум модела',
    vehicleModelCategorySort: 'Сортирај по категорији возила',
    vehicleModelDescription: 'Опис модела',
    vehicleModelList: 'Листа модела',
    vehicleModelManagement: 'Управљање моделом возила',
    vehicleModelName: 'Назив модела',
    vehicleModelQuery: 'Упит за модел возила',
    vehicleModelSeries: 'Серија модела',
    vehicleModelSorting: 'Сортирање модела',
    vehicleModelType: 'Тип модела',
    vehicleName: 'Ime vozila',
    vehicleNetworkEquipment: 'Уређај за умрежавање возила',
    vehicleOutboundCountry: 'Vehicle outbound country',
    vehicleRemark: 'Primedbe vozila',
    vehicleShareInstruction: 'Instrukcije za dijeljenje vozila',
    vehicleShareInstructionAdd: 'New vehicle sharing instructions',
    vehicleShareInstructionEdit: 'Уредити инструкције за делење автомобила',
    vehicleType: 'Мотор бр.',
    vehicleTypeSplicing: 'Vratiti se na modele vozila',
    vehicleUnbindingInstructions: 'Упутство за подношење захтева за одвезивање возила',
    versionCode: 'Број верзије',
    versionIntroduction: 'Версион Интродуцтион',
    versionManage: 'Управљање верзијама',
    versionManageList: 'Листа за управљање верзијама',
    versionMangeTip:
      'Напомена: Није дозвољено креирати верзију већу од броја верзије који је тренутно објављен на тржишту апликација! Особље за рад и одржавање треба да сачека да се најновија верзија објави на Гоогле Плаи-у или Апп Сторе-у, а затим да креира записе о верзији који одговарају броју најновије верзије. Прављење записа унапред није дозвољено.',
    versionPattern: 'Број верзије се може унети само као цео број од 0 до 999.',
    versionRequired: 'Број верзије не може бити празан',
    video: 'Видео',
    videoContent: 'Видео садржај',
    videoCover: 'Видео омот',
    videoDetail: 'Детаљи видеа',
    videoDisplayImages: 'Видео приказ',
    videoFile: 'Видео фајл',
    videoGuide: 'Конфигурација видео покретања',
    videoImageValidate: 'Захтеви за формат датотеке слике: пнг јпг јпег, однос слике 16:9, величина не већа од 5 МБ',
    videoList: 'Листа видео записа',
    videoMaxSizeValidate: 'Величина видеа не може бити већа од 150 МБ',
    videoSizeExceed: 'Molim vas, postavite video s a širinom i visinom %s',
    viewAllComment: 'Pogledajte sve recenzije',
    viewCount: 'број прегледа',
    viewCurrentLocation: 'Отворите апликацију да бисте у било ком тренутку видели тренутну локацију возила',
    viewCurrentLocation2: 'Отворите АПП да бисте видели тренутну локацију возила у било ком тренутку, што је згодно за проналажење возила из непосредне близине',
    viewDetails: 'проверите детаље',
    viewFeedBackRecords: 'Погледај записи отговора',
    viewLocation: 'Отворите АПП да бисте проверили локацију возила у било ком тренутку',
    viewModel: {},
    viewPush: 'Prikaži guranje',
    viewSeries: {},
    viewVehicleInfomation: 'Подршка за преглед дневне стазе за јахање, километражу, трајање, брзину и друге информације возила',
    views: 'Погледи',
    vin: 'VIN',
    virginia: 'Вирџинија',
    waitForReview: 'Чека се преглед',
    waitUploading: 'Отпремање, сачекајте',
    waitingManualReview: 'Чека се ручни преглед',
    waitingOnline: {},
    waitingPush: 'Иeka',
    wednesday: 'Środa',
    whatOTA: 'Шта је ОТА?',
    whyUseNavigation: 'Kako koristiti navigaciju',
    whyUseSetting: 'Kako napraviti opće postavke APP-a',
    withCountry: 'Земља/Регион (ИП)',
    withInformation: 'Sa informacijama',
    withTBOX: {},
    withdrawn: 'Povukla se',
    withoutCarOfNumber: 'Broj korisnika bez automobila',
    withoutTBOX: {},
    writeAccountToPass: 'Popunite informacije o nalogu i dovršite proveru identiteta',
    year: {},
    yes: 'Da.',
    youHaveFeedbackMessage: 'Имате ** повратне информације корисника које нису ефикасно пропраћене, молимо вас да их решите на време',
    youthVehicleOwner: {},
    yoyGrowth: 'Povećano za  Godišnji rast',
    zh_CN: 'кинески',
  },
};
